import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
import { IUpdateProps } from '~/interfaces/IUpdateProps';
import IEquipmentGroup from '../interfaces/IEquipmentGroup';

export async function getAllEquipmentGroups() {
  const response = await authFetch({
    url: '/equipment-group/',
    method: 'GET',
  });
  return response.data;
}

export async function getEquipmentGroups({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  name,
  code,
}: IParamsTable & { readonly name?: string; readonly code?: string } = {}) {
  const response = await authFetch({
    url: '/equipment-group/',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      name,
      code,
    },
  });
  return response.data;
}

export async function getEquipmentGroupById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/equipment-group/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function createEquipmentGroup(data: IEquipmentGroup) {
  const response = await authFetch({
    url: '/equipment-group/store',
    method: 'POST',
    data,
  });
  return response.data;
}

export async function updateEquipmentGroup(id: IUpdateProps, data: IEquipmentGroup) {
  const response = await authFetch({
    url: `/equipment-group/${id}`,
    method: 'PUT',
    data,
  });
  return response.data;
}

export async function deleteEquipmentGroup(id: IUpdateProps) {
  const response = await authFetch({
    url: `/equipment-group/${id}`,
    method: 'DELETE',
  });
  return response.data;
}